import * as React from "react";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../../../api";
import { ApplicationSettings } from "../../../../core";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import UpdateForm from "./UpdateForm";

interface IApplicationSettingsProps {
  data?: ApplicationSettings;
  reload?: () => void;
}

const ApplicationSettingsTab: React.FunctionComponent<IApplicationSettingsProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: ApplicationSettings) =>
      api.settings.updateApplicationSettings({
        ...data,
        receiptNoPrefix: Number(data.receiptNoPrefix),
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
      appSettings.reload();
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Application Settings</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Value
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Email</td>
                <td>{props.data?.email}</td>
              </tr>
              <tr>
                <td>Application Base Url</td>
                <td>{props.data?.applicationBaseUrl}</td>
              </tr>
              <tr>
                <td>Crm Base Url</td>
                <td>{props.data?.crmBaseUrl}</td>
              </tr>
              <tr>
                <td>Toll Free Number</td>
                <td>{props.data?.tollFreeNumber}</td>
              </tr>
              <tr>
                <td>Appointment Times</td>
                <td>{props.data?.appointmentTime?.start} - {props.data?.appointmentTime?.end}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default ApplicationSettingsTab;
